export default __webpack_public_path__ + "static/media/storageUnit1-afterB.a1c46860.jpg";